
import React from 'react';

type FooterSectionProps = {
  title: string;
  children: React.ReactNode;
};

const FooterSection = ({ title, children }: FooterSectionProps) => {
  return (
    <div>
      <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-900">
        {title}
      </h3>
      <ul className="mt-4 space-y-2">
        {children}
      </ul>
    </div>
  );
};

export default FooterSection;
